import { configureStore } from "@reduxjs/toolkit"
import Global from './data/global'
import Product from './data/product'

const store = configureStore({
    reducer:{
        Global,Product
    }
})



export default store